import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../header";

class showMore extends Component {
  render() {
    return (
      <>
        <Header showSearchBar={true} title={"سایر"} backUrl="/mainPage" />
        <div className="showMoreCom">
          <div className="invite">
            <Link to="/showMore/Refferal">
              <div className="mainInvite">
                <span>با دعوت از دوستان خود تخفیف ویژه بگیرید</span>
                <img src="/public/assets/icons/discountArrow.svg" alt="pic" />
                <img src="public/assets/icons/Discount.svg" alt="pic" />
              </div>
            </Link>
          </div>
          <div className="items">
            <Link className="itemDetail" to="/showMore/Support">
              <div className="circleLight">
                <img src="public/assets/icons/Support.svg" alt="pic" />
              </div>
              <span>پشتیبانی</span>
            </Link>
            <a className="itemDetail" href="tel:04132843535">
              <div className="circleLight">
                <img src="public/assets/icons/Supportphone.svg" alt="pic" />
              </div>
              <span> تماس با پشتیبانی</span>
            </a>
            <Link className="itemDetail" to={"/showMore/rules"}>
              <div className="circleLight">
                <img src="public/assets/icons/ruleUse.svg" alt="pic" />
              </div>
              <span>قوانین و شرایط استفاده</span>
            </Link>
            <Link className="itemDetail" to={"/AboutUs"}>
              <div className="circleLight">
                <img src="public/assets/icons/aboutUsIcon.svg" alt="pic" />
              </div>
              <span>درباره ما</span>
            </Link>
          </div>
        </div>
      </>
    );
  }
}
export default showMore;
